import { FRAMEWORKS_ENUM } from '@/shared/consts';
import { PaginationData } from '@/shared/dto';

export const TABLE_PAGINATION_LIMIT = 5;

export type CreateEnterpriseFrameworkDto = {
  code: FRAMEWORKS_ENUM;
  appId?: string;
  bundleId?: string;
  domain?: string;
  projectName?: string;
};

export type Enterprise = {
  key: string;
  id: string;
  name: string;
  description: string;
  emails: string[];
  frameworks: CreateEnterpriseFrameworkDto[];
  createdBy: string;
  expiresAt: Date;
  createdAt: Date;
  updatedAt: Date;
};

export type EnterpriseStore = {
  items: Enterprise[];
  isLoading: boolean;
  currentPage: number;
  currentLimit: number;
  searchColumn: string;
  searchValue?: string;
  pagination?: PaginationData;
  getItems: () => void;
  setCurrentPage: (value: number) => void;
  setSearchValue: (value: string) => void;
};
